import { Collections, TeamTag, TeamTagEntity } from '@uploadcam/common';
import { doc, Firestore, updateDoc } from 'firebase/firestore';
import { getCollectionRef } from '../../../../@harmony/angular';

export class UpdateTeamTagInteractor {
  constructor(private readonly db: Firestore) {}

  public async execute(
    teamId: string,
    tagId: string,
    name: string,
    isActive: boolean,
  ): Promise<TeamTag> {
    const collection = getCollectionRef<TeamTag>(
      this.db,
      Collections.TeamTags.replace('{id}', teamId),
    );

    const docRef = doc(collection, tagId);
    const entity: TeamTagEntity = {
      name: name.trim(),
      isActive,
    };

    await updateDoc(docRef, { ...entity });

    return new TeamTag(docRef.id, entity.name, entity.isActive);
  }
}
